import { render, staticRenderFns } from "./DShareDownload.vue?vue&type=template&id=ef0fdb46&scoped=true&"
import script from "./DShareDownload.vue?vue&type=script&lang=js&"
export * from "./DShareDownload.vue?vue&type=script&lang=js&"
import style0 from "./DShareDownload.vue?vue&type=style&index=0&id=ef0fdb46&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef0fdb46",
  null
  
)

export default component.exports